import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Button
} from 'react-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import history from '../../../core/history';

//Image
import { HostCtaArrowIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';
import s from './SeeAll.css';

class SeeAll extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    history.push('/s');
  }

  render() {
    return (
      <Button
        bsStyle="link"
        className={cx(s.seeAllBtn)}
        onClick={() => this.handleClick()}
      >
        <FormattedMessage {...messages.seeAll} />
        <HostCtaArrowIcon className={cx(s.seeAllBtnIcon, 'seeAllBtnIcon')} />
      </Button>
    );
  }
}

export default injectIntl(withStyles(s)(SeeAll));